import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=494c2444&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=494c2444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494c2444",
  null
  
)

export default component.exports